import { jsx as o } from "react/jsx-runtime";
import { hasAnyInstructions as m, getInstructionSections as d } from "../../utils/instructions.js";
import { Accordion as l } from "../Accordion/index.js";
import i from "./productInstructionsTab.module.js";
import { useTranslation as a } from "../../hooks/useTranslation.js";
import { SectionBlock as h } from "../SectionBlock/SectionBlock.js";
const x = ({
  productData: n,
  className: e,
  language: c
}) => {
  const { t: r } = a();
  return n && m(n, r) && /* @__PURE__ */ o("div", { className: e, children: /* @__PURE__ */ o(
    l,
    {
      className: i.accordion,
      header: r("use_and_storage"),
      headingLevel: "h2",
      children: /* @__PURE__ */ o("div", { className: i.accordionContent, children: d(n, r, c).map(
        (t, s) => t.condition && /* @__PURE__ */ o(h, { title: t.title, children: /* @__PURE__ */ o("p", { children: t.content }) }, s)
      ) })
    }
  ) });
};
export {
  x as ProductInstructionsTab
};
